function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

if (document.querySelector('.sc-product-comparison')) {
  const compareTabs = document.querySelectorAll('.product-comparison__tab');
  const comparisonTable = (parent) => {
    const tableEl = parent.querySelector('.product-comparison__table');

    return tableEl ? tableEl.querySelector('table') : null;
  };
  const comparisonProduct = document.querySelector('.product-comparison__product');
  // DATA OF ALL PRODUCTS
  let comparisonData = {};

  // SELECTED TAB ID // TYPE OF PRODUCTS
  let selectedTabId = '';

  // DOM ELEMENT OF DRAGGABLE PRODUCT
  let dragStartProduct;
  let isDragging;

  if (compareTabs.length && !window.localStorage.comparisonData) {
    if (!window.localStorage.comparisonData) {
      window.localStorage.comparisonData = JSON.stringify({});
    } else {
      comparisonData = {
        ...JSON.parse(window.localStorage.comparisonData),
      };
    }
  }
  let lessThanThreeProducts = true;
  let bottomEmptyEl;
  if (document.querySelector('.product-comparison__bottom-item.empty')) {
    bottomEmptyEl = document.querySelector('.product-comparison__bottom-item.empty').cloneNode(true);
    lessThanThreeProducts = false;
  }

  const selectors = {
    title: '.title > h2',
    image: '.product-image > img',
    price: '.product-price > .editor-text',
    btnLink: '.product-btn > a',
  };

  const getProductId = (el) => {
    const tableString = el.getAttribute('data-table');
    const priceText = el.querySelector(selectors.price).innerHTML;
    return {
      productId: el.getAttribute('data-productid'),
      title: el.querySelector(selectors.title).textContent,
      image: el.querySelector(selectors.image).getAttribute('data-path'),
      price: priceText,
      btnLink: el.querySelector(selectors.btnLink).href,
      table_data: tableString ? JSON.parse(tableString) : null,
    };
  };

  const setDeleteListener = (product) => {
    const event = isTouchDevice() ? 'touchend' : 'click';

    // eslint-disable-next-line no-use-before-define
    product.querySelector('.product-delete').addEventListener(event, handleDelete);
  };

  const setProduct = (product, secondProduct) => {
    if (!secondProduct) {
      return;
    }
    const {productId, title, image, price, btnLink} = secondProduct;
    product.setAttribute('data-productid', productId);
    /* eslint-disable */
    product.querySelector(selectors.title).textContent = title;
    product.querySelector(selectors.image).setAttribute('data-path', image);
    product.querySelector(selectors.image).src = image;
    product.querySelector(selectors.price).innerHTML = price;
    /* eslint-enable */
    const btn = product.querySelector(selectors.btnLink);
    if (btn) {
      btn.href = btnLink;
    }

    setDeleteListener(product);
  };

  const setComparisonData = (tab) => {
    const keyName = tab.getAttribute('data-tabid');
    const getElement = (el) => el.getAttribute('data-tab') === keyName;

    const tabContent = Array.from(document.querySelectorAll('.product-comparison__tab-content')).find(getElement);
    const comparedProducts = Array.from(tabContent.querySelectorAll('.product-comparison__items .product-comparison__product')).map(
      getProductId,
    );
    const bottomProducts = Array.from(tabContent.querySelectorAll('.product-comparison__bottom-items .product-comparison__product')).map(
      getProductId,
    );

    comparisonData[keyName] = {
      active: comparedProducts,
      bottom: bottomProducts,
    };
  };

  const setCellContent = (rowIndex, comparedProduct) => {
    if (!rowIndex) {
      return comparedProduct.title;
    }

    if (!comparedProduct.table_data) {
      return '';
    }
    return comparedProduct.table_data[rowIndex];
  };

  const createTables = () => {
    const parentTabs = document.querySelectorAll('.product-comparison__tab-content');
    parentTabs.forEach((parentTab) => {
      const parentTable = parentTab.querySelector('.product-comparison__table');
      if (!parentTable) {
        return;
      }
      const table = parentTable.querySelector('tbody');
      if (table) {
        const rows = table.querySelectorAll('tr');
        rows.forEach((el) => el.remove());
      }
      const dataString = parentTab.getAttribute('data-table');
      const tableHeaders = dataString ? JSON.parse(dataString) : [];

      tableHeaders.forEach((header, index) => {
        const tr = document.createElement('tr');
        const cell = index ? document.createElement('td') : document.createElement('th');
        cell.classList.add('table-header-col');
        cell.innerHTML = header;
        tr.append(cell);
        table.append(tr);
      });
    });
  };

  createTables();

  const setComparisonTable = (passedKeyName) => {
    const parentTab = passedKeyName
      ? document.querySelector(`[data-tab=${passedKeyName}]`)
      : document.querySelector('.product-comparison__tab-content.is-active');
    const keyName = passedKeyName || parentTab.getAttribute('data-tab');

    const products = parentTab.querySelector('.product-comparison__items');
    const dataIds = [];
    products.querySelectorAll('.product-comparison__product').forEach((el) => dataIds.push(el.getAttribute('data-productid')));

    const table = comparisonTable(parentTab);
    if (!table) {
      return;
    }

    const rows = table.querySelectorAll('tr');
    const comparedProducts = dataIds.map((productId) => comparisonData[keyName].active.find((product) => product.productId === productId));

    if (comparedProducts.length !== 3) {
      const all = products.querySelectorAll('.product-comparison__item');
      all.forEach((ele, index) => {
        if (ele.classList.contains('empty')) {
          comparedProducts.splice(index, 0, null);
        }
      });
    }
    table.parentElement.parentElement.style.display = comparedProducts.filter((el) => el).length === 0 ? 'none' : 'block';
    // get products table data

    rows.forEach((row, index) => {
      const children = row.querySelectorAll(index ? 'td' : 'th');
      if (children.length) {
        for (let i = 0; i < 3; i += 1) {
          const isProduct = comparedProducts[i];
          const newCellContent = isProduct ? setCellContent(index, comparedProducts[i]) : '';
          // if (comparedProducts[i]) {
          if (children[i + 1]) {
            // eslint-disable-next-line no-nested-ternary
            children[i + 1].textContent = newCellContent;
          } else {
            const cell = document.createElement(index ? 'td' : 'th');
            cell.textContent = newCellContent;
            row.append(cell);
          }
        }
      }
    });
  };
  const getCurrentSwipper = () => {
    if (document.querySelector('.product-comparison__tab-content.is-active').querySelector('.swiper')) {
      return document.querySelector('.product-comparison__tab-content.is-active').querySelector('.swiper').swiper;
    }
    return null;
  };

  const deleteBottom = (product, productId) => {
    const {bottom, active} = comparisonData[selectedTabId];
    const bottomIndex = bottom.findIndex((el) => el && el.productId === productId);
    // FUNCTIONALITY IF MIN 3 BOTTOM ITEMS NEEDED
    // if (bottom.length < 3) {
    //   product.parentNode.classList.add('empty');
    //   product.remove();
    //   bottom[bottomIndex] = null;
    // } else {
    const Swiper = getCurrentSwipper();
    Swiper.removeSlide(bottomIndex);
    Swiper.updateSlides();
    bottom.splice(bottomIndex, 1);
    // }
  };

  // const selectFirstBottom = function () {
  //   const { bottom } = comparisonData[selectedTabId];
  //   const first = bottom.find((el) => el);
  //   const parent = this.parentNode;
  //
  //   const product = document.querySelector(`[data-productid="${first.productId}"]`);
  //   dragStartProduct = {
  //     selectedProduct: product,
  //     id: first.productId,
  //   };
  //   // eslint-disable-next-line no-use-before-define
  //   swapItem(parent, null);
  //
  //   setComparisonTable();
  // };

  const noProducts = () => {
    const {active, bottom} = comparisonData[selectedTabId];

    return active.every((el) => !el) && bottom.length === 0;
  };

  const handleDelete = (event, isMass = false) => {
    if (event.type === 'touchend') {
      if (isDragging) {
        // cancel delete
        return;
      }

      const aTag = event.target.parentElement.parentElement.querySelector('.product-comparison__item-add');
      // const att = aTag.getAttribute('href');
      // aTag.setAttribute('href', '');
      aTag.style.pointerEvents = 'none';
      setTimeout(() => {
        aTag.style.pointerEvents = 'all';
      }, 500);
      // aTag.style.cursor = 'default';
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
    const comparisonTab = event.target.closest('.product-comparison__tab-content');
    lessThanThreeProducts = !comparisonTab.querySelector('.product-comparison__bottom-item.empty');

    const product = event.target.closest('.product-comparison__product');
    const parent = document.querySelector('.product-comparison__tab-content.is-active');
    const Swiper = getCurrentSwipper();
    // PRODUCT ID TO DELETE
    const productId = product.getAttribute('data-productid');

    // CHECK IF ACTIVE OR BOTTOM PRODUCT
    const isActiveProduct = !!product.closest('.product-comparison__items');

    const {active, bottom} = comparisonData[selectedTabId];
    if (lessThanThreeProducts) {
      let idToRemoveFromCookie = '';
      if (isMass) {
        idToRemoveFromCookie = event.target.dataset.productid;
      } else {
        idToRemoveFromCookie = event.target.parentElement.dataset.productid;
      }
      let cookieData = getCookie('wc_compare');
      cookieData = JSON.parse(cookieData);
      const index = cookieData ? cookieData.indexOf(idToRemoveFromCookie) : -1;
      if (index > -1) {
        cookieData.splice(index, 1);
      }
      setCookie('wc_compare', JSON.stringify(cookieData), 1);
      // deleteBottom(product, productId);
      product.parentNode.classList.add('empty');
      product.remove();
      setComparisonTable();
    } else if (isActiveProduct) {
      const emptyProduct = parent.querySelector('.product-comparison__bottom-item.empty');

      const bottomProduct = emptyProduct || document.createElement('div');
      bottomProduct.className = 'product-comparison__bottom-item';
      bottomProduct.draggable = true;
      const clonedProduct = product.cloneNode(true);

      bottomProduct.append(clonedProduct);
      // eslint-disable-next-line no-use-before-define
      bottomProduct.addEventListener('dragstart', dragStart);
      setDeleteListener(bottomProduct);

      const activeIndex = active.findIndex((el) => el && el.productId === productId);
      const [removedProduct] = active.splice(activeIndex, 1);
      const emptyCell = bottom.findIndex((el) => el === null);
      if (emptyCell > -1) {
        bottom[emptyCell] = removedProduct;
      } else {
        bottom.push(removedProduct);
      }

      if (!parent.querySelector('.product-comparison__bottom-item.empty')) {
        const swiperEl = document.createElement('div');

        swiperEl.className = 'swiper-slide';
        swiperEl.append(bottomEmptyEl.cloneNode(true));
        Swiper.appendSlide(swiperEl);
      }
      product.parentNode.classList.add('empty');
      product.remove();
      setComparisonTable();
    } else {
      let idToRemoveFromCookie = '';
      if (isMass) {
        idToRemoveFromCookie = event.target.dataset.productid;
      } else {
        idToRemoveFromCookie = event.target.parentElement.dataset.productid;
      }
      const cookieData = JSON.parse(getCookie('wc_compare'));
      const index = cookieData ? cookieData.indexOf(idToRemoveFromCookie) : -1;
      if (index > -1) {
        cookieData.splice(index, 1);
      }
      setCookie('wc_compare', JSON.stringify(cookieData), 1);
      deleteBottom(product, productId);

      if (noProducts()) {
        const bottomItem = parent.querySelector('.product-comparison__bottom-items');
        const deleteItems = parent.querySelector('.product-comparison__items-wrapper .product-comparison__delete-items');
        bottomItem.style.display = 'none';
        deleteItems.style.display = 'none';
      }
    }
  };

  const massDelete = function () {
    const type = this.parentNode.className === 'product-comparison__bottom-items' ? 'bottom' : 'active';
    const comparisonTab = this.closest('.product-comparison__tab-content');
    lessThanThreeProducts = !comparisonTab.querySelector('.product-comparison__bottom-item.empty');

    if (lessThanThreeProducts) {
      const activeItems = this.parentNode.querySelectorAll('.product-comparison__items > div > .product-comparison__product ');
      activeItems.forEach((el) =>
        handleDelete(
          {
            target: el,
          },
          true,
        ),
      );
    }
    if (type === 'bottom') {
      const bottomItems = this.parentNode.querySelectorAll('.product-comparison__product');
      bottomItems.forEach((el) =>
        handleDelete(
          {
            target: el,
          },
          true,
        ),
      );
    } else {
      const activeItems = this.parentNode.querySelectorAll('.product-comparison__items > div > .product-comparison__product ');
      activeItems.forEach((el) =>
        handleDelete({
          target: el,
        }),
      );
    }
  };

  const addDeleteEvent = (itemArray, type) => {
    const event = isTouchDevice() ? 'touchend' : 'click';
    itemArray.forEach((el) => {
      if (type === 'ADD') {
        el.addEventListener(event, handleDelete);
      }

      if (type === 'REMOVE') {
        el.removeEventListener(event, handleDelete);
      }
    });
  };

  const closeItem = (item) => {
    const activeItem = document.querySelector(`${item}.is-active`);
    if (activeItem) {
      activeItem.classList.remove('is-active');

      addDeleteEvent(activeItem.querySelectorAll('.product-delete'), 'REMOVE');
    }
  };

  const openItem = (item, itemParent, tabName) => {
    const parent = itemParent.closest('.product-comparison');
    const targetItem = Array.from(parent.querySelectorAll(item)).find((el) => el.getAttribute('data-tab') === tabName);

    if (targetItem) {
      targetItem.classList.add('is-active');

      const deleteItems = targetItem.querySelectorAll('.product-delete');
      addDeleteEvent(deleteItems, 'ADD');
    }

    if (selectedTabId !== tabName) {
      selectedTabId = tabName;
    }
  };

  const swapItem = (product, prevId) => {
    const {bottom, active} = comparisonData[selectedTabId];
    const isStartProductActive = dragStartProduct.selectedProduct.closest('.product-comparison__items');
    const isEndProductActive = product.closest('.product-comparison__items');
    const Swiper = getCurrentSwipper();

    const dragStartData = isStartProductActive ? active : bottom;
    const dragEndData = isEndProductActive ? active : bottom;
    const startIndex = dragStartData.findIndex((el) => el && el.productId === dragStartProduct.id);
    if (product.classList.contains('empty')) {
      product.classList.remove('empty');
      const newProduct = comparisonProduct.cloneNode(true);
      setProduct(newProduct, dragStartData[startIndex]);
      product.append(newProduct);

      dragEndData.push(dragStartData[startIndex]);

      // FUNCTIONALITY IF MIN 3 BOTTOM ITEMS NEEDED
      // if (startIndex < 3) {
      //   if (!isStartProductActive && bottom.length > 2) {
      //     const lastChild = dragStartProduct.selectedProduct.parentNode;
      //
      //     dragStartData.splice(startIndex, 1);
      //     lastChild.parentNode.remove();
      //     Swiper.updateSlides();
      //     Swiper.update();
      //     if (bottom.length === 3) {
      //       Swiper.slidePrev();
      //     }
      //   } else {
      //     if (isStartProductActive && isEndProductActive) {
      //       dragStartData.splice(startIndex, 1);
      //     } else {
      //       dragStartData[startIndex] = null;
      //     }
      //
      //     dragStartProduct.selectedProduct.parentNode.classList.add('empty');
      //   }
      //   dragStartProduct.selectedProduct.remove();
      // } else {

      if (isStartProductActive) {
        dragStartProduct.selectedProduct.parentElement.classList.add('empty');
      } else {
        Swiper.removeSlide(startIndex);
        dragStartData.splice(startIndex, 1);
      }
      dragStartProduct.selectedProduct.remove();
      // }
    } else {
      setProduct(product, dragStartData[startIndex]);
      const prevProduct = dragEndData.find((el) => el && el.productId === prevId);
      setProduct(dragStartProduct.selectedProduct, prevProduct);

      const [newActive] = dragStartData.splice(startIndex, 1);
      const endIndex = dragEndData.findIndex((el) => el && el.productId === prevId);
      const [newBottom] = dragEndData.splice(endIndex, 1);

      dragStartData.splice(startIndex, 0, newBottom);
      dragEndData.splice(endIndex, 0, newActive);
    }
  };

  let active = false;
  // TODO visible dragged item
  // let draggableProduct;
  // let currentX;
  // let currentY;
  // let initialX;
  // let initialY;
  // let xOffset = 0;
  // let yOffset = 0;

  const dragStart = function (e) {
    const product = this.querySelector('.product-comparison__product');
    if (product && e.type === 'touchstart') {
      e.preventDefault();
    }

    if (product) {
      dragStartProduct = {
        selectedProduct: product,
        id: product.getAttribute('data-productid'),
      };
    }
  };

  const dragOver = function (e) {
    // HANDLING OF UI COMPONENT WHEN DRAGGiNG
    e.preventDefault();
  };
  // const setTranslate = function (xPos, yPos, el) {
  //   // eslint-disable-next-line no-param-reassign
  //   el.style.transform = `translate3d(${xPos}px, ${yPos}px, 0)`;
  // };
  const drag = function (e) {
    isDragging = true;
    if (active) {
      // TODO: show draggable item
      e.preventDefault();
      //
      // if (e.type === 'touchmove') {
      //   currentX = e.touches[0].clientX - initialX;
      //   currentY = e.touches[0].clientY - initialY;
      // }
      //
      // xOffset = currentX;
      // yOffset = currentY;
      // setTranslate(currentX, currentY, draggableProduct);
    }
  };

  const touchDrop = function (e) {
    isDragging = false;
    const compProducts = document.querySelectorAll('.product-comparison__item');
    const posX = e.changedTouches[0].clientX;
    const posY = e.changedTouches[0].clientY;
    let selectedProduct;
    compProducts.forEach((prod) => {
      const size = prod.getBoundingClientRect();

      if (size.left < posX && size.right > posX && size.top < posY && size.bottom > posY) {
        selectedProduct = prod.querySelector('.product-comparison__product') || prod;
      }
    });

    const prevId = selectedProduct ? selectedProduct.getAttribute('data-productid') : null;

    active = false;
    // draggableProduct.remove();
    // draggableProductImg = null;
    if (!selectedProduct || !dragStartProduct) {
      return;
    }

    swapItem(selectedProduct, prevId);
    setComparisonTable();
    dragStartProduct = null;
  };

  const dragDrop = function (e) {
    const product = this.querySelector('.product-comparison__product');
    const prevId = product ? product.getAttribute('data-productid') : null;

    active = false;
    swapItem(product || this, prevId);
    setComparisonTable();
  };

  const addEventListeners = function () {
    const draggables = document.querySelectorAll(`.product-comparison__bottom-item${isTouchDevice() ? '' : ', .product-comparison__item'}`);
    const dragListItems = document.querySelectorAll('.product-comparison__item');
    const deleteItems = document.querySelectorAll('.product-comparison__delete-items');
    deleteItems.forEach((delBtn) => delBtn.addEventListener('click', massDelete));

    draggables.forEach((draggable) => {
      draggable.setAttribute('draggable', true);
      if (isTouchDevice()) {
        draggable.addEventListener('touchstart', dragStart);
        // draggable.addEventListener('pointerdown', dragStart);
        draggable.addEventListener('touchmove', drag);
        draggable.addEventListener('touchend', touchDrop, false);
      } else {
        draggable.addEventListener('dragstart', dragStart);
      }
    });

    dragListItems.forEach((item) => {
      if (isTouchDevice()) {
        item.addEventListener('touchend', touchDrop, false);
      } else {
        item.addEventListener('dragover', dragOver);
        item.addEventListener('drop', dragDrop);
      }
    });
  };

  compareTabs.forEach((compareTab) => {
    setComparisonData(compareTab);
    const tabName = compareTab.getAttribute('data-tabid');

    setComparisonTable(tabName);
    addEventListeners();

    if (compareTab.classList.contains('is-active')) {
      // INITIAL TAB
      selectedTabId = tabName;
      const deleteItems = document.querySelector('.product-comparison__tab-content.is-active').querySelectorAll('.product-delete');
      addDeleteEvent(deleteItems, 'ADD');
    }
    compareTab.addEventListener('click', () => {
      closeItem('.product-comparison__tab');
      closeItem('.product-comparison__tab-content');
      closeItem('.product-comparison__table');
      closeItem('.product-comparison__accordion');
      openItem('.product-comparison__tab-content', compareTab, tabName);
      openItem('.product-comparison__table', compareTab, tabName);
      openItem('.product-comparison__accordion', compareTab, tabName);
      compareTab.classList.add('is-active');
    });
  });

  // **********************************************************
  // Product Comparison Slider
  // **********************************************************

  const productComparisonSliderElements = document.querySelectorAll('[data-slider="product-comparison-slider"]');

  const productComparisonSliderOptions = {
    slidesPerView: 3,
    spaceBetween: 6,
    navigation: {
      nextEl: '.swiper-button-prev',
      prevEl: '.swiper-button-next',
    },
    touchStartPreventDefault: false,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 15,
        allowTouchMove: false,
      },
    },
  };

  const loadSwiper = () => {
    productComparisonSliderElements.forEach((el) => {
      const productComparisonParent = el.closest('.bottom-items');
      const arrowRight = productComparisonParent.querySelector('.arrow-right');
      const arrowLeft = productComparisonParent.querySelector('.arrow-left');

      productComparisonSliderOptions.navigation.nextEl = arrowRight;
      productComparisonSliderOptions.navigation.prevEl = arrowLeft;

      // eslint-disable-next-line no-new
      new Swiper(el, productComparisonSliderOptions);
    });
  };

  loadSwiper();

  // **********************************************************
  // synchronize scrolling on mobile
  // **********************************************************
  const setScrollEvents = () => {
    const contents = document.querySelectorAll('.product-comparison__tab-content');

    contents.forEach((content) => {
      const productComparisonItems = content.querySelector('.product-comparison__items');
      const productComparisonTable = content.querySelector('.product-comparison__table');

      productComparisonTable.addEventListener('scroll', () => {
        const scrollOffset = productComparisonTable.scrollLeft;
        productComparisonItems.scrollLeft = scrollOffset;
      });

      productComparisonItems.addEventListener('scroll', () => {
        const scrollOffset = productComparisonItems.scrollLeft;
        productComparisonTable.scrollLeft = scrollOffset;
      });
    });
  };

  setScrollEvents();
}
